<div class="container">
  <form [formGroup]="updatePasswordFormControl" (ngSubmit)="onSubmitPasswordForm()">
    <mat-toolbar>      
      <span>Cambio contrase&ntilde;a</span>
      <span class="sgd-spacer"></span>
      <button type="submit" [disabled]="!updatePasswordFormControl.valid || fetchingUpdatePassword"
        class="update-button" mat-flat-button>
        <div class="btn-login-content">
          @if (fetchingUpdatePassword) {
          <mat-spinner diameter="20" color="warn"></mat-spinner>
          }@else{
          <p>Guardar</p>
          }
        </div>
      </button>
    </mat-toolbar>
    <br>
    <div class="row">
      <div class="col-12">
        <mat-form-field class="full-width">
          <mat-label>Contrase&ntilde;a actual</mat-label>
          <input matInput formControlName="currentPassword" #currentPasswordInput [type]="hideActual() ? 'password' : 'text'" />
          <button mat-icon-button type="button" matSuffix (mousedown)="toggleVisibility(hideActual, $event)"
            (mouseup)="toggleVisibility(hideActual, $event)" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideActual()">
            <mat-icon>{{hideActual() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Nueva contrase&ntilde;a</mat-label>
          <input matInput formControlName="newPassword" [type]="hideNueva() ? 'password' : 'text'" />
          <button mat-icon-button type="button" matSuffix (mousedown)="toggleVisibility(hideNueva, $event)"
            (mouseup)="toggleVisibility(hideNueva, $event)" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideNueva()">
            <mat-icon>{{hideNueva() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Confirmar contrase&ntilde;a</mat-label>
          <input matInput formControlName="confirmPassword" [type]="hideConfirmar() ? 'password' : 'text'" />
          <button mat-icon-button type="button" matSuffix (mousedown)="toggleVisibility(hideConfirmar, $event)"
            (mouseup)="toggleVisibility(hideConfirmar, $event)" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideConfirmar()">
            <mat-icon>{{hideConfirmar() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="col-12">
        @if (incorrectPasswordError) {
        <mat-error>La contrase&ntilde;a actual es incorrecta</mat-error>
        }
        @if (updatePasswordFormControl.hasError('passwordMismatch')) {
        <mat-error>Las contrase&ntilde;as no coinciden</mat-error>
        }
        @if (submitted && updatePasswordFormControl.get('currentPassword')?.value && updatePasswordFormControl.get('newPassword')?.value && updatePasswordFormControl.get('currentPassword')?.value === updatePasswordFormControl.get('newPassword')?.value) {
        <mat-error>La nueva contrase&ntilde;a no puede ser igual a la actual</mat-error>
        }
        
        <div class="password-requirements" style="margin-top: 16px;">
          <p style="display: flex; align-items: center; gap: 8px; font-weight: 500; margin-bottom: 8px;">
            <mat-icon>info</mat-icon>
            Requisitos de la contraseña:
          </p>
          <ul style="list-style: none; padding-left: 0;">
            <li style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;"
                [style.color]="!updatePasswordFormControl.get('newPassword')?.hasError('minLength') && updatePasswordFormControl.get('newPassword')?.value ? '#4caf50' : '#666'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('minLength') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Mínimo 10 caracteres
            </li>
            <li style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;"
                [style.color]="!updatePasswordFormControl.get('newPassword')?.hasError('uppercase') && updatePasswordFormControl.get('newPassword')?.value ? '#4caf50' : '#666'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('uppercase') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Debe contener letras mayúsculas
            </li>
            <li style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;"
                [style.color]="!updatePasswordFormControl.get('newPassword')?.hasError('lowercase') && updatePasswordFormControl.get('newPassword')?.value ? '#4caf50' : '#666'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('lowercase') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Debe contener letras minúsculas
            </li>
            <li style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;"
                [style.color]="!updatePasswordFormControl.get('newPassword')?.hasError('number') && updatePasswordFormControl.get('newPassword')?.value ? '#4caf50' : '#666'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('number') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Debe contener al menos un número
            </li>
            <li style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;"
                [style.color]="!updatePasswordFormControl.get('newPassword')?.hasError('specialChar') && updatePasswordFormControl.get('newPassword')?.value ? '#4caf50' : '#666'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('specialChar') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Debe contener al menos un carácter especial (!@#$%^&*...)
            </li>
          </ul>
        </div>
      </div>
    </div>
  </form>
</div>
